export function keysToSingleValue(keys, value) {
    const result = {};
    for (const key of keys) {
        result[key] = value;
    }
    return result;
}
